import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { GameSettingsService } from 'src/app/core/firebase/gameSettings.service';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { BetSizes, INITIAL_BET_SIZES, INITIAL_RAISE_SIZES, RaiseSizes } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.state';
import { SOPO_DIALOG_DATA } from 'src/app/sopo-popup/interfaces/dialog';
import { ProfilePageService } from '../../../../profile-page.service';

@Component({
    selector: 'app-bet-buttons',
    templateUrl: './bet-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./bet-buttons.component.scss'],
    standalone: false
})
export class BetButtonsComponent implements OnInit, OnDestroy {
    gameThemeSettingsSubscription: Subscription;
    betSizes: BetSizes = {...INITIAL_BET_SIZES};
    raiseSizes: RaiseSizes = {...INITIAL_RAISE_SIZES};
    betSizingArray = ["1/5","1/4","1/3","2/5","1/2","3/5","2/3","3/4","1","1.5","2"];
    raiseSizingArray = ["2","2.2","2.4","2.5","2.7","3","3.5","4","4.5","5"];
    changeBetPopoverId = 'edit-bet-popover-id';
    private _popoverOpened = false;
    zIndex: number = 2002;

    constructor(
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
        private gameSettingsService: GameSettingsService,
        private ref: ChangeDetectorRef,
        @Optional() @Inject (SOPO_DIALOG_DATA) public data: any,
        private popoverCtrl: PopoverController,
        private profilePageService: ProfilePageService
    ) {}

    ngOnInit() {
        this.gameThemeSettingsSubscription = this.gameThemeSettingsDispatcher.getGameThemeSettingsState().pipe(
            map((settings) => { 
                return {
                    bet: settings.betSizes,
                    raise: settings.raiseSizes
                }
            })
        ).subscribe((betOptions) => {
            this.betSizes = betOptions.bet;
            this.raiseSizes = betOptions.raise;
            this.ref.markForCheck();
        });
        if (this.profilePageService.activePopover.bets) this.zIndex = 50005;
    }

    getBetSizingArray(selected: string) {
        let array: string[] = [];
        Object.values(this.betSizingArray).forEach(bet => {
            if (bet !== selected && Object.values(this.betSizes).some(betSize => betSize === bet)) return;
            array.push(bet);
        });
        return array;
    }

    getRaiseSizingArray(selected: string) {
        let array: string[] = [];
        Object.values(this.raiseSizingArray).forEach(raise => {
            if (raise !== selected && Object.values(this.raiseSizes).some(raiseSize => raiseSize === raise)) return;
            array.push(raise);
        });
        return array;
    }

    selectChangedBet(event, bet: string) {
        this.gameSettingsService.saveBetSizes({
            ...this.betSizes,
            [bet] : event
        });
    }

    selectChangedRaise(event,raise: string) {
        this.gameSettingsService.saveRaiseSizes({
            ...this.raiseSizes,
            [raise] : event
        });
    }

    onClick() {
        if (!this._popoverOpened) this._popoverOpened = true;
    }

    onDismiss() {
        if (this._popoverOpened) this._popoverOpened = false;
    }

    ngOnDestroy(): void {
        if(this.gameThemeSettingsSubscription) {
            if (this._popoverOpened) this.popoverCtrl.dismiss(this.changeBetPopoverId);
            this.gameThemeSettingsSubscription.unsubscribe();
        }
    }
}
